import React, { useState } from "react";
import CustomAvatar from "../../Core/CommonV2/CustomAvatar";
import DropTarget from "./Components/DropTarget";
import { useAppDispatch } from "../../Core/redux/hooks";
import { updateVault } from "../../Core/redux/slices/vault.slice";
import { Link } from "react-router-dom";

interface ProjectProps {
  id: string;
  title: string;
  projectImage?: string;
  colorCode?: string;
}

interface ProjectTitleContainerProps {
  project: ProjectProps;
  isDragOver?: boolean;
}

const ProjectTitleContainer: React.FC<ProjectTitleContainerProps> = ({
  project,
  isDragOver,
}) => {
  const dispatch = useAppDispatch();

  return (
    <div
      className={`w-[211px] h-[76px] cursor-pointer rounded-lg border ${
        isDragOver ? "border-primary-600 bg-primary-50" : "border-gray-200"
      } relative`}
    >
      <Link
        to={`/library/${project.id}`}
        onClick={(e) => {
          dispatch(
            updateVault({ key: "currentSelectedProject", value: project })
          );
          return e;
        }}
      >
        <div className="flex w-[211px] h-[76px] items-center px-3 gap-x-[6px]">
          <CustomAvatar
            size={20}
            title={project.title}
            whiteText
            src={project.projectImage}
            color={project.colorCode}
          />
          <p className="out-500-14 text-gray-700 truncate max-w-[170px]">
            {project.title}
          </p>
        </div>
      </Link>
    </div>
  );
};

interface DroppableProjectContainerProps {
  project: ProjectProps;
  currentDragSource: { type: string; id: string | number } | null;
  onDrop: (
    projectId: string,
    dragItem: { type: string; id: string | number }
  ) => void;
}

export const DroppableProjectContainer: React.FC<
  DroppableProjectContainerProps
> = ({ project, onDrop, currentDragSource }) => {
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  return (
    <DropTarget
      id={project.id}
      type="project"
      onDrop={() => {
        if (currentDragSource && currentDragSource.id) {
          onDrop(project.id, currentDragSource);
        }
      }}
      onDropTargetChange={(id, { isOver, canDrop }) => {
        setIsDraggingOver(isOver && canDrop);
      }}
    >
      {(monitor) => (
        <ProjectTitleContainer
          project={project}
          isDragOver={monitor.isOver && monitor.canDrop}
        />
      )}
    </DropTarget>
  );
};

export default ProjectTitleContainer;
